import React, { useContext, useReducer, useState } from 'react';
import PageHeader from 'components/PageHeader';
import { Header, Icon, Divider, Form, Segment, Button } from 'semantic-ui-react';
import { GlobalContext } from 'globalContext';
import request from 'services/http';
import { toast } from 'react-toastify';

function reducer(state, action) {
    if (action.payload) return { ...state, ...action.payload };
    return state;
}

export const Importar = () => {
    const [{ empresas }] = useContext(GlobalContext);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [form, setForm] = useReducer(reducer, {
        empresa: '',
        numero: '',
        xml: null,
    });

    const unidades = empresas?.filter((it) => it.tipo === 'POSTO');

    function handleChange(event, props) {
        let { value, name } = props;
        if (name === 'xml') {
            value = event.currentTarget.files[0]
        };
        setForm({ payload: { [name]: value } });
    }

    function handleSubmit() {
        if (!form.empresa || !form.numero || !form.xml)
            toast.error('Por favor, preencha todos os campos antes de enviar.');
        else {
            setIsSubmitting(true);

            const formData = new FormData();
            for (const key of Object.keys(form)) {
                formData.set(key, form[key]);
            }

            request({
                url: '/validfisco/xml-import',
                method: 'POST',
                body: formData,
                inheritError: true
            }).toPromise()
                .then(() => toast.success('XML importado com sucesso, aguarde de 15 a 30 minutos para esta nota estár disponível!', { autoClose: 5000 }))
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.message, { autoClose: 5000 });
                    }
                })
                .finally(() => setIsSubmitting(false));
        }
    }

    return (
        <div id="importar-xmls" className="page-content">
            <PageHeader />

            <Segment className="subcontent pr-2 pl-2 pb-4">
                <div className="row mb-3">
                    <div className="col d-flex flex-column">
                        <Header as="h3" className="m2-4 ml-4">
                            <Icon.Group size="big">
                                <Icon name="attach" className="primary-color" />
                            </Icon.Group>
                            <Header.Content className="primary-color">
                                Importar XMLs
                                <Header.Subheader className="secondary-color">
                                    <strong>NF-e</strong>
                                </Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>

                <Divider fitted style={{ margin: '0 12px 10px 12px', borderTopWidth: '2px' }} />

                <div className="row flex-grow-1 flex-column">
                    <div className="col d-flex align-items-center flex-column justify-content-center">
                        <Form size="mini" onSubmit={handleSubmit} loading={isSubmitting} noValidate>
                            <Form.Select
                                label="Unidade"
                                options={
                                    unidades?.map((it) => ({
                                        text: it.nomeEmpresa,
                                        value: it._id,
                                    })) || []
                                }
                                placeholder="Selecione a unidade"
                                search
                                selectOnBlur={false}
                                required
                                name="empresa"
                                onChange={handleChange}
                            />
                            <Form.Input
                                placeholder="Ex: 12345"
                                label="Número NF"
                                required
                                name="numero"
                                onChange={handleChange}
                                autoComplete="off"
                            />
                            <Form.Input
                                style={{ overflow: 'hidden' }}
                                type="file"
                                label="XML"
                                required
                                accept=".xml"
                                name="xml"
                                onChange={handleChange}
                            />
                            <Button
                                className="btn btn-primary"
                                floated="right"
                                icon="send"
                                content="Enviar"
                            />
                        </Form>
                    </div>
                </div>
            </Segment>
        </div>
    );
};
